module.exports = __webpack_public_path__ + "static/media/img-1.e250fe59.png";